/** 是否为 XP 嵌入式客户端（兼容 os=xp / reffer=xpsystem） */
export function isXpClient(query: Record<string, unknown> | undefined | null): boolean {
  if (!query) return false
  const os = String(query.os || '').toLowerCase()
  if (os === 'xp') return true
  const reffer = String(query.reffer || '').toLowerCase()
  return reffer === 'xpsystem' || reffer.includes('xpsystem')
}
